import React from 'react';
import { graphql, StaticQuery } from 'gatsby';

import 'lazysizes';
import 'typeface-montserrat';
import 'bootstrap/dist/css/bootstrap.css';

import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Navigation from './_blog/Navigation';
import Footer from './_homepage/footer';

// import '../assets/css/bootstrap.min.css';
// import '../assets/css/mediumish.css';
// import '../assets/css/base.css';
import '../assets/_blog/main.scss';
import Favicon from '../assets/img/favicon.ico';

const pageQuery = graphql`
	query CategoryQuery {
		allContentfulCategory {
			edges {
				node {
					title
					seo {
						title
						description {
							description
						}
					}
					slug
				}
			}
		}
	}
`;

class Template extends React.PureComponent {
	render() {
		const { children } = this.props;

		return (
			<>
				<Helmet>
					<link rel="icon" href={Favicon} />
				</Helmet>
				<StaticQuery
					query={pageQuery}
					render={data => {
						const categories = get(data, 'allContentfulCategory.edges');

						return (
							<div className="blogPageSection">
								<Navigation categories={categories} />
								{children}
								<Footer />
							</div>
						);
					}}
				/>
			</>
		);
	}
}

Template.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Template;
